import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da02b0ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { withDefaults } from "vue";
import { getTranslate } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardTitleText',
  props: {
    title: { default: "" },
    resume: null,
    resumeLongText: { type: Boolean, default: false },
    resumeFont: { default: "Roboto" },
    font: { default: "Roboto" },
    fontSize: { default: "2.5rem" },
    invert: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
    paddingBlock: { default: "2.5rem" },
    paddingInline: { default: "3rem" },
    background: { default: "transparent" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "6ecc843e": (__props.paddingBlock),
  "56aad3c5": (__props.paddingInline),
  "13530d53": (__props.background),
  "5faf1e55": (__props.fontSize)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({ 'card-title': true, invert: __props.invert, center: __props.center })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['title', __props.font])
    }, _toDisplayString(_unref(getTranslate)(__props.title)), 3),
    _createElementVNode("div", {
      class: _normalizeClass(['resume', __props.resumeFont]),
      innerHTML: _unref(getTranslate)(__props.resume, __props.resumeLongText)
    }, null, 10, _hoisted_1)
  ], 2))
}
}

})